module.exports = __webpack_public_path__ + "img/ctrl-fswap-stub-0.5c5c6259.svg";